<template>
  <div>
    <form @submit.prevent="handleSubmit" class="mt-[25px] flex flex-col items-center animate__animated animate__fadeIn">
      <div
          class="w-[90%] md:w-[90%] lg:w-full flex flex-col gap-[16px] xsm:gap-[20px] sm:gap-[20px] md:gap-[20px] lg:gap-[34px] bg-white bg-opacity-10 border backdrop-blur-md rounded-[22px] px-[15px] pb-[12px] pt-[20px] sm:px-[30px] sm:pb-[45px] sm:pt-[75px] md:px-[50px] md:py-[35px] lg:px-[50px] lg:py-[90px] text-white relative shadow-xl max-w-[980px]">

        <div v-if="isFormValid"
             class="p-[10px] md:p-[20px] absolute top-[-45px] sm:top-[-60px] md:top-[-70px] lg:top-[-90px] left-1/2 transform -translate-x-1/2 w-[60px] h-[60px] sm:w-[100px] sm:h-[100px] md:w-[100px] md:h-[100px] lg:w-[160px] lg:h-[160px] flex items-center justify-center rounded-full text-white text-2xl font-bold shadow-md border-4 border-[#FFFFFF99] animate__animated animate__fadeIn"
             style="background: linear-gradient(180deg, #E69F29 0%, #DC7E1E 100%)">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75.107"
               height="75.01" viewBox="0 0 75.107 75.01">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectangle_213" data-name="Rectangle 213" width="75.107" height="75.01" fill="#fff"/>
              </clipPath>
            </defs>
            <g id="Group_419" data-name="Group 419" transform="translate(0 0)">
              <g id="Group_418" data-name="Group 418" transform="translate(0 0)" clip-path="url(#clip-path)">
                <path id="Path_586" data-name="Path 586"
                      d="M73.861,8.536c-15.408,17.9-29.4,47.067-35.209,59.974a11.015,11.015,0,0,1-10.045,6.5h0a11.012,11.012,0,0,1-9.085-4.789L1.491,43.9a8.51,8.51,0,0,1,12.73-11.12L28.3,45.513S43.533,18.89,66.786,1.06a5.176,5.176,0,0,1,7.075,7.476"
                      transform="translate(0 0)" fill="#fff"/>
              </g>
            </g>
          </svg>
        </div>

        <div
            class="text-[18px] xsm:text-[23px] sm:text-[23px] md:text-[23px] lg:text-[36px] tracking-[-0.72px] leading-[1.2] xsm:leading-[1.2] sm:leading-normal md:leading-[24px] lg:leading-[44px] text-white border-2 border-[#FFFFFF98] text-center py-[10px] sm:py-[20px] md:py-[35px] px-4 rounded-[34px] font-extrabold mb-0 xsm:mb-[22px] sm:mb-[22px] md:mb-[22px] lg:mb-[39px] shadow-md"
            style="background: linear-gradient(180deg, #E69F29 0%, #DC7E1E 100%)">
          Reveal your programmatic superpowers...<br/>
          <span class="font-normal">Drop your email like it's hot.</span>
        </div>

        <div class="flex flex-col gap-[5px] xsm:gap-[12px] animate__animated animate__fadeInUp"
             style="animation-delay: 0.3s;">
          <label for="name"
                 class="pl-[17px] text-[17px] xsm:text-[17px] sm:text-[17px] md:text-[17px] lg:text-[28px] text-white font-medium">Name
            <span
                class="text-[#E69F29]">*</span></label>
          <input
              id="name"
              type="text"
              class="w-full px-[30px] py-[6px] xsm:py-[10px] sm:py-[10px] md:py-[13px] md:px-[17px] lg:py-[21px] rounded-full bg-white bg-opacity-20 border-2 border-[#FFFFFF33] text-white text-[19px] xsm:text-[19px] sm:text-[19px] md:text-[19px] lg:text-[30px] focus:outline-none focus:ring-2 focus:ring-[#E69F29AB] focus:bg-opacity-100 focus:text-[#2F2F2F]"
              :value="userInfo.name"
              @input="updateName($event.target.value)"
              required
          />
        </div>

        <div class="flex flex-col gap-[5px] xsm:gap-[12px] animate__animated animate__fadeInUp"
             style="animation-delay: 0.6s;">
          <label for="name"
                 class="flex flex-row justify-between pl-[17px] text-[17px] xsm:text-[17px] sm:text-[17px] md:text-[17px] lg:text-[28px] text-white font-medium">
            <span>Email <span class="text-[#E69F29]">*</span></span>
            <span v-if="userInfo.email && !isEmailValid"
                  class="text-[13px] xsm:text-[17px] sm:text-[17px] md:text-[17px] lg:text-[28px] italic text-[#c1370b]">
            Enter a valid email address.
          </span>
          </label>
          <input
              id="email"
              type="email"
              class="w-full px-[30px] py-[6px] xsm:py-[10px] sm:py-[10px] md:py-[13px] md:px-[17px] lg:py-[21px] rounded-full bg-white bg-opacity-20 border-2 border-[#FFFFFF33] text-white text-[19px] xsm:text-[19px] sm:text-[19px] md:text-[19px] lg:text-[30px] focus:outline-none focus:ring-2 focus:ring-[#E69F29AB] focus:bg-opacity-100 focus:text-[#2F2F2F]"
              :value="userInfo.email"
              @input="updateEmail($event.target.value)"
              required
          />

        </div>

        <div class="flex flex-col gap-[5px] xsm:gap-[12px] animate__animated animate__fadeInUp"
             style="animation-delay: 0.9s;">
          <label for="name"
                 class="pl-[17px] text-[17px] xsm:text-[17px] sm:text-[17px] md:text-[17px] lg:text-[28px] text-white font-medium">Company
            <span
                class="text-[#E69F29]">*</span></label>
          <input
              id="company"
              type="text"
              class="w-full px-[30px] py-[6px] xsm:py-[10px] sm:py-[10px] md:py-[13px] md:px-[17px] lg:py-[21px] rounded-full bg-white bg-opacity-20 border-2 border-[#FFFFFF33] text-white text-[19px] xsm:text-[19px] sm:text-[19px] md:text-[19px] lg:text-[30px] focus:outline-none focus:ring-2 focus:ring-[#E69F29AB] focus:bg-opacity-100 focus:text-[#2F2F2F]"
              :value="userInfo.company"
              @input="updateCompany($event.target.value)"
              required
          />
        </div>

        <div
            @click=updateAcceptGdpr($event.target.value)
            class="flex items-center cursor-pointer transition-colors mt-0 xsm:mt-[22px] sm:mt-[22px] md:mt-[22px] lg:mt-[39px] animate__animated animate__fadeInUp"
            style="animation-delay: 1.2s;"
        >
          <div
              class="w-[23px] h-[23px] xsm:w-[23px] xsm:h-[23px] sm:w-[23px] sm:h-[23px] md:w-[23px] md:h-[23px] lg:w-[40px] lg:h-[40px]">
            <div
                class="w-[23px] h-[23px] xsm:w-[23px] xsm:h-[23px] sm:w-[23px] sm:h-[23px] md:w-[23px] md:h-[23px] lg:w-[40px] lg:h-[40px] rounded-full border flex items-center justify-center">
              <div
                  v-if="this.isAccepted === 'true'"
                  class="w-[13px] h-[13px] xsm:w-[13px] xsm:h-[13px] sm:w-[13px] sm:h-[13px] md:w-[13px] md:h-[13px] lg:w-[25px] lg:h-[25px] rounded-full bg-white"
              ></div>
            </div>
          </div>
          <span class="ms-[1.5vw] text-[17px] sm:text-[17px] md:text-[17px] lg:text-[28px] text-white"> I agree to the processing of my personal data according to the
            <a href="https://orangeclickmedia.com/privacy-policy" target="_blank"
               class="underline ml-1">Privacy Policy</a></span>
        </div>
      </div>

      <button
          type="submit"
          :disabled="!isFormValid"
          class="xs:text-[19px] sm:text-[26px] md:text-[26px] lg:text-[42px] bg-[#E69F29] hover:bg-white hover:text-[#DC7E1E] text-white px-[15%] py-[10px] md:px-[90px] md:py-[12px] lg:px-[166px] lg:py-[25px] rounded-full font-semibold tracking-[-0.84px] mt-[20px] md:mt-[30px] lg:mt-[80px]"
      >
        CONTINUE
      </button>
    </form>
  </div>

  <div v-if="toastMessage" class="fixed bottom-10 left-1/2 transform -translate-x-1/2">
    <div id="toast-warning"
         class="flex items-center p-4 w-auto max-w-full text-gray-500 bg-white rounded-lg shadow-lg"
         role="alert">
      <div
          class="inline-flex items-center justify-center flex-shrink-0 w-[24px] h-[24px] text-yellow-500 bg-yellow-100 rounded-lg">
        <svg class="w-[18px] h-[18px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
             viewBox="0 0 20 20">
          <path
              d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z"/>
        </svg>
        <span class="sr-only">Warning icon</span>

      </div>
      <div class="ml-3 text-[20px] font-light whitespace-nowrap">The email has been used again!</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Step2Page",
  props: {
    userInfo: Object
  },
  data() {
    return {
      isAccepted: 'false',
      toastMessage: '',
    };
  },
  computed: {
    isEmailValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.userInfo.email.trim());
    },
    isFormValid() {
      return this.userInfo.name.trim() !== '' &&
          this.userInfo.email.trim() !== '' &&
          this.userInfo.company.trim() !== '' &&
          this.userInfo.acceptGdpr;
    },
  },
  methods: {
    updateName(value) {
      this.$emit('update-user-info', {...this.userInfo, name: value});
    },
    updateCompany(value) {
      this.$emit('update-user-info', {...this.userInfo, company: value});
    },
    updateEmail(value) {
      this.$emit('update-user-info', {...this.userInfo, email: value});
    },
    updateAcceptGdpr() {
      this.isAccepted = 'true';
      this.$emit('update-user-info', {...this.userInfo, acceptGdpr: this.isAccepted});
    },
    showToast(message) {
      this.toastMessage = message;
      setTimeout(() => {
        this.toastMessage = '';
      }, 3000);
    },
    async handleSubmit() {
      let now = new Date()
      const salesPerson = new URLSearchParams(window.location.search).get('sales');

      let dataForCollectionData = {
        name: this.userInfo.name,
        email: this.userInfo.email,
        company: this.userInfo.company,
        date: (now.getTime()),
        salesPerson,
      }

      console.log('dataForCollectionData ', dataForCollectionData)
      await fetch('https://form-to-kv-worker.ocm.workers.dev/', {
        method: 'POST',
        body: JSON.stringify(dataForCollectionData),
        headers: {'content-type': 'application/json'}
      })
          .then(response => {
            console.log(response.status)
            if (this.isFormValid && (response.status !== 409 && response.status !== 404 && response.status !== 500)) {
              this.$emit('next-step');
            } else if (response.status === 409) {
              this.showToast('The email has been used again!');
            }
          })
          .catch(error => console.error('Error upload user:', error));
    },
  }
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #e49e29;
  color: white;
}

@media only screen and (max-width: 400px) {
  #toast-warning {
    padding: 0.5rem;
  }
}
</style>